module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cJ9cm2/image/Cover.jpg?1720819934056",
      "alt": "This image is the cover for the book The Miocene Megalodon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Miocene Megalodon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Dive into a world of friendship and adventure in "), _c('em', [_vm._v("The Miocene Megalodon: Meggles and the Don of the Ocean!")]), _vm._v(" Join Meggles, a curious Megalodon, as she embarks on a thrilling journey to uncover the secrets that lie hidden in the depths of the Mariana Trench. Accompanied by her diverse group of ocean-dwelling friends, Meggles swims through the dark waters, facing the unknown and the possibility of being trapped in the abyss forever.")]), _c('p', [_vm._v("Will Meggles and her companions find a way to swim back to the surface, or will they succumb to the fate of extinction, lost forever at the bottom of the ocean? Dive in and find out in this captivating tale of underwater exploration and the unbreakable bonds of friendship. "), _c('em', [_vm._v("The Miocene Megalodon: Meggles and the Don of the Ocean")]), _vm._v(" promises an unforgettable adventure that will keep you hooked until the very last page!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dr. Jamey M. Long\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "8.0pt",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Author Dr. Jamey M. Long is the author of "), _c('em', [_vm._v("Bison the White Buffalo")]), _vm._v(", "), _c('em', [_vm._v("The Miocene Megalodon: Meggles and the Don of the Ocean")]), _vm._v(", and business and education books. He is the owner of A Possum’s Company, LLC, which provides curriculum, reading, workshops, and educational materials for schools across America His books have been recognized as a valuable asset by several historical foundations and are sold in their museums and gift shops. He is a high school teacher. Dr. Long is also a member of the faculty at George Mason University and Northern Virginia Community College and was nominated for the NVCC Alumni Federation Faculty of the Year Award. He was an educator at Holy Cross Academy teaching children in grades K-8. He has earned a DBA and MEd from William Howard Taft University and remains busy supporting educational programs, schools, businesses, and serving as the Youth Minister at his church. Jamey currently resides in Virginia.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0